import { useEffect, useRef } from "react";

// Visibility-aware polling: runs `callback` immediately, then every `intervalMs`,
// but pauses while the browser tab is hidden and refetches the moment it becomes
// visible again. Re-runs immediately whenever `deps` change.
export function usePolling(callback, intervalMs, deps = []) {
  const saved = useRef(callback);
  saved.current = callback;

  useEffect(() => {
    let timer = null;
    const tick = () => { if (!document.hidden) saved.current(); };
    const start = () => { if (timer == null) { tick(); timer = setInterval(tick, intervalMs); } };
    const stop = () => { if (timer != null) { clearInterval(timer); timer = null; } };
    const onVisibility = () => { if (document.hidden) stop(); else start(); };

    start();
    document.addEventListener("visibilitychange", onVisibility);
    return () => { stop(); document.removeEventListener("visibilitychange", onVisibility); };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
}
